import { useEffect } from 'react';
import { Button, ButtonStyles, Icon, Icons, Tooltip } from '@silverfort/sf-components';
import { LAYOUT_PAGE_DATA } from './TowerLayoutUtils';
import { useTowerLayout } from './TowerLayoutProvider';
import { useLocation } from 'react-router-dom';
import { getMenuItemIdByPath } from '../TowerMenu/TowerMenuUtils';
import { useAppDrawer } from '../components/AppDrawer/AppDrawerProvider';
import ReportsDrawer from '../components/ReportsDrawer/ReportsDrawer';
import { useIsCloudOnly } from '../components/SystemSettings/hooks/featureFlags/useIsCloudOnly';

const TowerLayout = ({ selectedItem }) => {
    const {
        hideHeader,
        layoutContent,
        layoutHeader,
        layoutContentLeft,
        layoutContentIcon,
        hideReportsButton: hideReportsButtonLayout
    } = useTowerLayout();
    const location = useLocation();
    const isCloudOnly = useIsCloudOnly();

    let layoutItem = selectedItem;

    useEffect(() => {
        if (!selectedItem) {
            layoutItem = getMenuItemIdByPath(location.pathname);
        }
    }, [location.pathname, selectedItem]);

    const { displayContent } = useAppDrawer();

    if (!layoutItem) {
        layoutItem = getMenuItemIdByPath(location.pathname);
    }

    const pageAllowsReports = !!(layoutItem && LAYOUT_PAGE_DATA[layoutItem]?.showReports);
    const hideReportsButton = hideReportsButtonLayout || isCloudOnly || !pageAllowsReports;

    const showBanner =
        layoutHeader || (layoutItem && LAYOUT_PAGE_DATA[layoutItem] && !LAYOUT_PAGE_DATA[layoutItem]?.hideBanner);

    if (!showBanner || hideHeader) {
        return <></>;
    }

    const openReportsDrawer = () => {
        displayContent(<ReportsDrawer />);
    };

    return (
        <div className="bg-sf-white ml-16 py-4 px-6 h-16 shadow-sf-small w-[calc(100vw - 64px)] flex justify-between items-center">
            <div className="flex gap-2 items-center">
                {layoutContentLeft && <div>{layoutContentLeft}</div>}
                {layoutContentIcon ? (
                    layoutContentIcon
                ) : layoutItem && LAYOUT_PAGE_DATA[layoutItem] ? (
                    <Icon size={20} icon={LAYOUT_PAGE_DATA[layoutItem].icon} />
                ) : null}
                <span className="font-sf text-18 text-sf-gray-800 font-medium">
                    {layoutHeader ||
                        (layoutItem && LAYOUT_PAGE_DATA[layoutItem] ? LAYOUT_PAGE_DATA[layoutItem].title : '')}
                </span>
                {layoutItem && LAYOUT_PAGE_DATA[layoutItem]?.EA && (
                    <div className="rounded h-6 text-12 gap-1 font-medium font-sf px-2 flex items-center text-sf-positive-500 bg-sf-positive-100">
                        <Icon icon={Icons.Star} className="text-sf-positive-500" />
                        <div>Early Availability</div>
                    </div>
                )}
            </div>
            <div className="flex gap-2 items-center">
                {layoutContent && <div>{layoutContent}</div>}
                {!hideReportsButton && (
                    <div>
                        <Tooltip title={'Reports'}>
                            <Button
                                iconRight={Icons.DocEmpty}
                                buttonStyle={ButtonStyles.Primary}
                                onClick={openReportsDrawer}
                            />
                        </Tooltip>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TowerLayout;
